import React, { FC } from "react";
import { useSelector } from "react-redux";
import styles from "./DesktopNavbar.module.css";
import logo from "../../../assets/logo.svg";
import profile from "../../../assets/profile_icon.svg";

interface DesktopNavbarProps {}

const DesktopNavbar: FC<DesktopNavbarProps> = () => {
  const merchant = useSelector(
    // @ts-ignore
    (state) => state.authenticationReducer.merchantDetails,
  );
  return (
    <div className={styles.Navbar}>
      <div className={styles.Brand}>
        <div className={styles.Image}>
          <img src={logo} alt="logo" />
        </div>
        <div className={styles.Title}>iK Invoice</div>
      </div>
      <div className={styles.Merchant}>
        <div className={styles.Name}>
          Welcome
          {merchant.companyName && <span>,&nbsp;{merchant.companyName}</span>}
        </div>
        <img src={profile} alt="profile" />
      </div>
    </div>
  );
};

export default DesktopNavbar;
